"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.StyledCircle = exports.StyledSwitch = exports.StyledHiddenCheckboxInput = exports.StyledChip = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const { blue } = tokens_1.COLOURS.primary;
const SWITCH = {
    sizes: {
        small: {
            icons: tokens_1.SIZES["1.5"],
            height: tokens_1.SIZES["2"],
            width: tokens_1.SIZES["3"],
            circleInset: tokens_1.SIZES["0.25"],
        },
        medium: {
            icons: tokens_1.SIZES["2"],
            height: tokens_1.SIZES["3"],
            width: tokens_1.SIZES["4"],
            circleInset: tokens_1.SIZES["0.5"],
        },
    },
    colours: {
        off: {
            backgroundColor: tokens_1.COLOURS.greyscale.stone,
        },
        green: {
            backgroundColor: tokens_1.COLOURS.primary.green["100"],
        },
    },
};
exports.StyledChip = styled_components_1.default.span `
    display: flex;
    min-width: ${({ size }) => SWITCH.sizes[size].width}};
    height: ${({ size }) => SWITCH.sizes[size].height};
    border-radius: ${({ size }) => SWITCH.sizes[size].height};
    margin-top: 0.25rem;
    padding: ${({ size }) => SWITCH.sizes[size].circleInset};
    transition: 0.4s;
    ${({ active, colour }) => active ? SWITCH.colours[colour] : SWITCH.colours["off"]};
    box-sizing: border-box;

    svg {
        height: ${({ size }) => SWITCH.sizes[size].icons};
        width: ${({ size }) => SWITCH.sizes[size].icons};
        transform: translateX(-${({ active, size }) => active ? SWITCH.sizes[size].icons : 0});
        opacity: 1;
    }
`;
exports.StyledHiddenCheckboxInput = styled_components_1.default.input `
    opacity: 0;
    width: 0;
    margin: 0;
    padding: 0;

    &:focus ~ ${exports.StyledChip} {
        box-shadow: 0px 0px 0px 4px ${blue[50]};
    }
`;
exports.StyledSwitch = styled_components_1.default.label `
    display: inline-flex;
    cursor: pointer;
    flex-direction: ${({ switchPosition }) => switchPosition === "right" ? "row-reverse" : "row"};
`;
exports.StyledCircle = styled_components_1.default.span `
    background-color: ${tokens_1.COLOURS.greyscale.white};
    border-radius: 50%;
    height: ${({ size }) => SWITCH.sizes[size].icons};
    width: ${({ size }) => SWITCH.sizes[size].icons};
    transition: 0.4s;
    transform: translateX(
        ${({ active, size }) => active ? SWITCH.sizes[size].icons : 0}
    );
    z-index: 1;
`;
exports.StyledLabel = styled_components_1.default.div `
    padding-left: ${({ switchPosition }) => switchPosition === "right" ? 0 : tokens_1.SIZES["1.5"]};
    padding-right: ${({ switchPosition }) => switchPosition === "right" ? tokens_1.SIZES["1.5"] : 0};
    text-align: ${({ switchPosition }) => switchPosition === "right" ? "right" : "left"};
    min-height: ${tokens_1.SIZES["3"]};
`;
//# sourceMappingURL=Switch.styles.js.map